import styled from 'styled-components'

import { RangeRow } from '@/presentation/components/Slider/Slider.styles'

// Slider length at full size, in px. It shrinks with the chart, never grows past it.
export const SLIDER_LENGTH = 200

// Space between the slider and the chart's edge, in px at full size.
const EDGE_GAP = 8

// Laid out along the marker's x axis, which the marker turns to follow the chart
// edge; the chart lies on the +y side, so the slider sits on the -y side. It is
// scaled (inline, it changes on every frame of a zoom) around the edge's start
// corner, so the gap shrinks along with it.
export const Container = styled.div`
  position: absolute;
  left: 0;
  bottom: ${EDGE_GAP}px;
  width: ${SLIDER_LENGTH}px;
  transform-origin: 0 calc(100% + ${EDGE_GAP}px);
  border-radius: 10px;
  box-shadow: -2px 4px 6px 0px ${({ theme }) => `${theme.colors.secondary}80`};
  cursor: default;

  ${RangeRow} {
    padding-right: 24px;
  }
`
